import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_voyage-ia-1/artifacts/nfa9thxc_IMG_6183.JPEG";

export default function LandingHero() {
  const { t } = useLanguage();

  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-24">
      <div className="grid lg:grid-cols-2 gap-16 items-center">

        {/* Text */}
        <div className="animate-fade-in-up">
          <p className="section-label mb-5">{t("landing.hero_label")}</p>
          <h1
            className="text-5xl sm:text-6xl lg:text-7xl leading-tight mb-6"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623", letterSpacing: "-0.01em" }}
          >
            {t("landing.hero_title1")}
            <span className="block italic" style={{ color: "#C17F59" }}>{t("landing.hero_title2")}</span>
          </h1>
          <p className="text-base lg:text-lg text-[#5C554E] mb-8 leading-relaxed" style={{ fontFamily: "'Lora', Georgia, serif" }}>
            {t("landing.hero_desc")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/register" className="btn-primary flex items-center gap-2" data-testid="hero-cta-btn">
              {t("landing.hero_cta")} <ArrowRight size={15} strokeWidth={1.5} />
            </Link>
            <Link to="/about" className="btn-secondary text-sm" data-testid="hero-about-link">
              {t("landing.hero_secondary")}
            </Link>
          </div>
          <p className="text-xs text-[#9A8F86] mt-5 italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>
            Gratuit pour démarrer · À partir de 29 € pour débloquer votre itinéraire validé
          </p>
        </div>

        {/* Hero image */}
        <div className="animate-fade-in delay-200">
          <div className="relative overflow-hidden sm:overflow-visible">
            <div className="bg-[#F9F6F0] p-4 pb-12 border border-[#DCD4C6] shadow-lg sm:transform sm:-rotate-1 animate-float">
              <img
                src={HERO_IMG}
                alt="Boussole sur carte ancienne"
                className="w-full h-[280px] sm:h-[320px] object-cover"
                loading="lazy"
              />
              <p className="mt-3 text-center text-base text-[#5C554E]" style={{ fontFamily: "'Caveat', cursive", color: "#8B5E34" }}>
                Chaque voyage a sa propre histoire
              </p>
            </div>
            <div
              className="absolute bottom-0 right-0 sm:-bottom-4 sm:-right-4 bg-[#C17F59] text-[#F9F6F0] px-5 py-3 shadow-lg"
              style={{ borderRadius: "2px", fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600 }}
            >
              <p className="text-2xl">Dès 29 €</p>
              <p className="text-xs opacity-80" style={{ fontFamily: "'Lora', Georgia, serif" }}>paiement unique</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
